const Dashed=()=>{
    return(
        <div className=" mt-10 opacity-[0.3] mb-5">
            <div className="border-b-2 border-white border-dashed mx-8">
            </div>
        </div>
    );
}
export default Dashed;